var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122.584,
    height: 122.584,
    fill: "#977BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4847 16.8155C57.8668 11.9813 64.7175 11.9813 66.0995 16.8155L69.9288 30.2097C70.8136 33.3045 74.3497 34.7692 77.1637 33.2065L89.3426 26.4431C93.7381 24.002 98.5822 28.8462 96.1412 33.2417L89.3778 45.4206C87.8151 48.2346 89.2797 51.7707 92.3746 52.6555L105.769 56.4847C110.603 57.8668 110.603 64.7175 105.769 66.0995L92.3746 69.9288C89.2797 70.8136 87.8151 74.3497 89.3778 77.1637L96.1412 89.3426C98.5822 93.7381 93.7381 98.5822 89.3426 96.1412L77.1637 89.3778C74.3497 87.8151 70.8136 89.2797 69.9288 92.3746L66.0995 105.769C64.7175 110.603 57.8668 110.603 56.4847 105.769L52.6555 92.3746C51.7707 89.2797 48.2346 87.8151 45.4206 89.3778L33.2417 96.1412C28.8462 98.5822 24.002 93.7381 26.4431 89.3426L33.2065 77.1637C34.7692 74.3497 33.3045 70.8136 30.2097 69.9288L16.8155 66.0995C11.9813 64.7175 11.9813 57.8668 16.8155 56.4847L30.2097 52.6555C33.3045 51.7707 34.7692 48.2346 33.2065 45.4206L26.4431 33.2417C24.002 28.8462 28.8462 24.002 33.2417 26.4431L45.4206 33.2065C48.2346 34.7692 51.7707 33.3045 52.6555 30.2097L56.4847 16.8155Z",
    fill: "#FCB1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar);
export default __webpack_public_path__ + "static/media/hero-star.72f179eb3ad5a78bfd305a87de2a5871.svg";
export { ForwardRef as ReactComponent };